import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import addDays from 'date-fns/add_days';
import startOfWeek from 'date-fns/start_of_week';
import { resolve } from 'path';
import { getTeamByCompany } from './core/cacheService'
import { resolveTeamHeightFromTeams } from '@/utils/teamHeight'
import { getCompanyTimezone, toCompanyDate } from './utils/companyTimezone'
export default {
  namespaced: true,
  state: {
    questions_name: [],
    membersall: [],
    team: '',
    teamHeight: '',
    teamselected: '',
    teamkeys: [],
    dailyopened: [],
    weeklyopened: [],
    feedback: [],
    inactive: [],
    active: [],
    passive: [],
    potential: [],
    datalist: [],
    datalistAll: [],
    dateshow: '',
    questions: [
      {
        quest_id: '-Kgn7oxLPPWlbM_ZDc_h',
        name: 'Personal Growth',
        dimpic: 'Personal-Growth@2x',
        sent: 0,
        accept: 0,
        success: 0
      },
      {
        quest_id: '-L0J5FFsGQYVkfcGujWo',
        name: 'Recognition',
        dimpic: 'Recognition@2x',
        sent: 0,
        accept: 0,
        success: 0
      },
      {
        quest_id: '-L1QWPtZvax_KlJgpNxF',
        name: 'Feedback',
        dimpic: 'Feedback@2x',
        sent: 0,
        accept: 0,
        success: 0
      }
    ],
    countAll: '',
    countAct: '',
    countPas: '',
    countPot: '',
    loadingTable: true

  },
  mutations: {
    setThisMonth(state: any, result: string) {
      state.thismonth = result
    },
    setWeekOfYear(state: any, result: string) {
      state.weekofyear = result
    },
    setWeekPrevious(state: any, result: string) {
      state.weekprevious = result
    },
    setWeekPrevious2(state: any, result: string) {
      state.weekprevious2 = result
    },
    setDailyOpened(state: any, result: any) {
      state.dailyopened = result
    },
    setWeeklyOpened(state: any, result: any) {
      state.weeklyopened = result
    },
    setFeedback(state: any, result: any) {
      state.feedback = result
    },
    setInactive(state: any, result: any) {
      state.inactive = result
    },
    setActive(state: any, result: any) {
      state.active = result
    },
    setPassive(state: any, result: any) {
      state.passive = result
    },
    setPotential(state: any, result: any) {
      state.potential = result
    },
    setDateShow(state: any, result: string) {
      state.dateshow = result
    },
    setTeamHeight(state: any, value: any) {
      state.teamHeight = value
    },
    setMemberall(state: any, result: any) {
      state.membersall = result
    },
    setQuestionsName(state: any, result: any) {
      state.questions_name[result.id] = result.value
    },
    setTeamSelected(state: any, value: any) {
      state.teamselected = value
    },
    setDataList(state: any, result: any) {
      state.datalist = result
    },
    setDataListAll(state: any, result: any) {
      state.datalistAll = result
    },
    setCountAll(state: any, result: any) {
      state.countAll = result
    },
    setCountAct(state: any, result: any) {
      state.countAct = result
    },
    setCountPas(state: any, result: any) {
      state.countPas = result
    },
    setCountPot(state: any, result: any) {
      state.countPot = result
    },
    setLoadingTable(state: any, status: any) {
      state.loadingTable = status
    }
  },
  actions: {
    resetState({ commit }: any) {
      commit('setDataList', [])
      commit('setCountAll', "(" + 0 + ")")
    },
    setWeekOfYear({ commit }: any) {
      const dateNow = new Date()
      //const weekofyear = moment().tz("Asia/Bangkok").startOf('isoWeek').format('YYYY-w')
      const weekofyear = format(startOfWeek(dateNow, { weekStartsOn: 1 }), 'GGGG-W')
      //const weekprevious = moment().add(-7, 'days').tz("Asia/Bangkok").startOf('isoWeek').format('YYYY-w')
      const weekprevious = format(startOfWeek(addDays(dateNow, -7), { weekStartsOn: 1 }), 'GGGG-W')
      //const weekprevious2 = moment().add(-14, 'days').tz("Asia/Bangkok").startOf('isoWeek').format('YYYY-w')
      const weekprevious2 = format(startOfWeek(addDays(dateNow, -14), { weekStartsOn: 1 }), 'GGGG-W')

      //const today = moment().tz("Asia/Bangkok").format('d')
      const today: any = format(dateNow, 'd')
      let startdate = ''
      let enddate = ''
      if (today > 1) {
        const date = today - 1
        //startdate = moment().add(-(date * 1), 'days').tz("Asia/Bangkok").format('MMM D')
        startdate = format(addDays(dateNow, -(date * 1)), 'MMM D')
      } else if (today == 0) {
        //startdate = moment().add(-6, 'days').tz("Asia/Bangkok").format('MMM D')
        startdate = format(addDays(dateNow, -6), 'MMM D')
      } else {
        //startdate = moment().tz("Asia/Bangkok").format('MMM D')
        startdate = format(dateNow, 'MMM D')
      }
      if (today == 0) {
        //enddate = moment().add(-2, 'days').tz("Asia/Bangkok").format('MMM D')
        enddate = format(addDays(dateNow, -2), 'MMM D')
      } else
        if (today < 5) {
          const date = 5 - today
          //enddate = moment().add(+(date * 1), 'days').tz("Asia/Bangkok").format('MMM D')
          enddate = format(addDays(dateNow, +(date * 1)), 'MMM D')
        } else if (today == 6) {
          //enddate = moment().add(-1, 'days').tz("Asia/Bangkok").format('MMM D')
          enddate = format(addDays(dateNow, -1), 'MMM D')
        } else {
          //enddate = moment().tz("Asia/Bangkok").format('MMM D')
          enddate = format(dateNow, 'MMM D')
        }
      const thismonth: any = format(dateNow, 'YYYY-MM')
      commit('setThisMonth', thismonth)
      commit('setWeekOfYear', weekofyear)
      commit('setWeekPrevious', weekprevious)
      commit('setWeekPrevious2', weekprevious2)
      commit('setDateShow', `${startdate} - ${enddate}`)

    },
    async getData({ commit, dispatch, rootState, state }: any, selectTeam: any) {
      const timezone = await getCompanyTimezone(rootState.authen.user.company)
      const companyNow = toCompanyDate(new Date(), timezone)
      // const team: { [key: string]: any; } = {};
      if (rootState.team.teamsall.length > 0) {
        _.forEach(rootState.team.teamsall, (value) => {
          state.teamkeys[value.key] = value
        });
      } else {
        const team2 = await getTeamByCompany(rootState.authen.user.company)//(await firebase.database().ref('team').orderByChild("company").equalTo(`${rootState.authen.user.company}`).once('value')).val()
        _.forEach(team2, (value, key) => {
          state.teamkeys[key] = value
        });
      }
      if (!selectTeam) {
        if (!state.teamHeight) {
          if (!state.teamHeight && rootState.main.teamHeight) {
            selectTeam = rootState.main.teamHeight
            commit('setTeamHeight', selectTeam)
          }
          if (!state.teamHeight) {
            if (rootState.team.teamsall.length > 0) {
              selectTeam = resolveTeamHeightFromTeams(rootState.team.teamsall)
              commit('setTeamHeight', selectTeam)
              if (selectTeam) {
                commit('main/setTeamHeight', selectTeam, { root: true })
              }
            } else {
              const team_All = await getTeamByCompany(rootState.authen.user.company)
              selectTeam = resolveTeamHeightFromTeams(team_All)
              commit('setTeamHeight', selectTeam)
              if (selectTeam) {
                commit('main/setTeamHeight', selectTeam, { root: true })
              }
            }
          }
        } else {
          selectTeam = state.teamHeight
        }
      }
      commit('setTeamSelected', selectTeam)
      if (state.membersall.length == 0) {
        const users: Array<any> = [];

        for(const arrData in rootState.main.allUser){
          const u = rootState.main.allUser[arrData]
          u.key = arrData
          users.push(u)
        }
        // await firebase.database().ref('users').orderByChild('company').equalTo(`${rootState.authen.user.company}`).once('value', async snapshot => {
        //   snapshot.forEach((arrData): any => {
        //     const u = arrData.val()
        //     u.key = arrData.key
        //     users.push(u)
        //   });
          await firebase.database().ref('users_not_used').orderByChild('company').equalTo(`${rootState.authen.user.company}`).once('value', async snapshot => {
            snapshot.forEach((arrData): any => {
              const u = arrData.val()
              u.key = arrData.key
              users.push(u)
            });
            await firebase.database().ref('users_employee_exit').orderByChild('company').equalTo(`${rootState.authen.user.company}`).once('value', snapshot => {
              snapshot.forEach((arrData): any => {
                const u = arrData.val()
                u.key = arrData.key
                users.push(u)
              });
              commit('setMemberall', users)

              dispatch('getDailyOpened', selectTeam)

              dispatch('getWeeklyOpened', selectTeam)

              dispatch('getFeedback', selectTeam)

              // dispatch('getInactive', selectTeam)

              dispatch('getActive', selectTeam)

              dispatch('getPassive', selectTeam)

              dispatch('getPotential', selectTeam)

              dispatch('getQuestionData', selectTeam)
            });
          });
        // });

        // }
      }else{
        dispatch('getDailyOpened', selectTeam)

        dispatch('getWeeklyOpened', selectTeam)

        dispatch('getFeedback', selectTeam)

        // dispatch('getInactive', selectTeam)

        dispatch('getActive', selectTeam)

        dispatch('getPassive', selectTeam)

        dispatch('getPotential', selectTeam)

        dispatch('getQuestionData', selectTeam)
      }

    },
    async getDataFullList({ commit, dispatch, rootState, state }: any, value: any) {
      commit('setLoadingTable', true)
      commit('setDataList', [])
      const objData: { [key: string]: firebase.firestore.DocumentData; } = {}
      let listData: Array<any> = []
      let countAll = 0
      let countAct = 0
      let countPas = 0
      let countPot = 0
      let selectTeam = value.selectTeam;
      const status = value.status;
      if (!selectTeam) {
        if (!state.teamHeight) {
          if (!state.teamHeight && rootState.main.teamHeight) {
            selectTeam = rootState.main.teamHeight
            commit('setTeamHeight', selectTeam)
          }
          if (!state.teamHeight) {
            if (rootState.team.teamsall.length > 0) {
              selectTeam = resolveTeamHeightFromTeams(rootState.team.teamsall)
              commit('setTeamHeight', selectTeam)
              if (selectTeam) {
                commit('main/setTeamHeight', selectTeam, { root: true })
              }
            } else {
              const team_All = await getTeamByCompany(rootState.authen.user.company)
              selectTeam = resolveTeamHeightFromTeams(team_All)
              commit('setTeamHeight', selectTeam)
              if (selectTeam) {
                commit('main/setTeamHeight', selectTeam, { root: true })
              }
            }
          }
        } else {
          selectTeam = state.teamHeight
        }
      }
      const insightTeams: any = [];
      const criticalTeams: any = [];
      const timezone = await getCompanyTimezone(rootState.authen.user.company)
      const companyNow = toCompanyDate(new Date(), timezone)
      firebase.firestore().collection('report_weekly_manager_direct_all').where('company', '==', rootState.authen.user.company).where('date', '>', format(addDays(companyNow, -30), 'YYYY-MM-DD')).orderBy('date').get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          if (insightTeams[doc.data().quest_id + '==' + doc.data().email] === undefined) {
            insightTeams[doc.data().quest_id + '==' + doc.data().email] = [];
          }
          insightTeams[doc.data().quest_id + '==' + doc.data().email].push(doc.data());
        });
        const color = ['red', 'yellow'];
        for (const x in insightTeams) {
          const questions = x.split('==');
          if (questions[0] === '-L1QWPtZvax_KlJgpNxF' && insightTeams[x].length > 1) {//feedback
            const lastweek = insightTeams[x][insightTeams[x].length - 2];
            const thisweek = insightTeams[x][insightTeams[x].length - 1];
            if (color.includes(lastweek.color) || color.includes(thisweek.color)) {
              if (criticalTeams[questions[1]] === undefined) {
                criticalTeams[questions[1]] = [];
              }
              criticalTeams[questions[1]]['Feedback'] = 'Feedback';
            }
          } else if (questions[0] === '-L1Qug-PhtzVOR2Dr5q7' && insightTeams[x].length > 1) {//real manager
            const lastweek = insightTeams[x][insightTeams[x].length - 2];
            const thisweek = insightTeams[x][insightTeams[x].length - 1];
            if (color.includes(lastweek.color) || color.includes(thisweek.color)) {
              if (criticalTeams[questions[1]] === undefined) {
                criticalTeams[questions[1]] = [];
              }
              criticalTeams[questions[1]]['Rel. Manager'] = 'Rel. Manager';
            }
          } else if (questions[0] === '-L36rxTgLhZTL4mq4SV1' && insightTeams[x].length > 1) {//wellness
            const lastweek = insightTeams[x][insightTeams[x].length - 2];
            const thisweek = insightTeams[x][insightTeams[x].length - 1];
            if (color.includes(lastweek.color) || color.includes(thisweek.color)) {
              if (criticalTeams[questions[1]] === undefined) {
                criticalTeams[questions[1]] = [];
              }
              criticalTeams[questions[1]]['Wellness'] = 'Wellness';
            }
          } else if (questions[0] === '-L0J5FFsGQYVkfcGujWo' && insightTeams[x].length > 1) {//recognition
            const lastweek = insightTeams[x][insightTeams[x].length - 2];
            const thisweek = insightTeams[x][insightTeams[x].length - 1];
            if (color.includes(lastweek.color) || color.includes(thisweek.color)) {
              if (criticalTeams[questions[1]] === undefined) {
                criticalTeams[questions[1]] = [];
              }
              criticalTeams[questions[1]]['Recognition'] = 'Recognition';
            }
          } else if (questions[0] === '-L1FmpFO-v8IZc_B5EB7') {//satisfaction
            const thisweek = insightTeams[x][insightTeams[x].length - 1];
            if (color.includes(thisweek.color)) {
              if (criticalTeams[questions[1]] === undefined) {
                criticalTeams[questions[1]] = [];
              }
              criticalTeams[questions[1]]['Satisfaction'] = 'Satisfaction';
            }
          } else if (questions[0] === '-Kgs549ClADmNQwoNbbG') {//Rel. Colleagues
            const thisweek = insightTeams[x][insightTeams[x].length - 1];
            if (color.includes(thisweek.color)) {
              if (criticalTeams[questions[1]] === undefined) {
                criticalTeams[questions[1]] = [];
              }
              criticalTeams[questions[1]]['Rel. Colleagues'] = 'Rel. Colleagues';
            }
          } else if (questions[0] === '-Kgn7oxLPPWlbM_ZDc_h') {//Personal Growth
            const thisweek = insightTeams[x][insightTeams[x].length - 1];
            if (color.includes(thisweek.color)) {
              if (criticalTeams[questions[1]] === undefined) {
                criticalTeams[questions[1]] = [];
              }
              criticalTeams[questions[1]]['Personal Growth'] = 'Personal Growth';
            }
          } else if (questions[0] === '-LtOL_iR1N-ev2b_8Tmg') {//Company Alignment
            const thisweek = insightTeams[x][insightTeams[x].length - 1];
            if (color.includes(thisweek.color)) {
              if (criticalTeams[questions[1]] === undefined) {
                criticalTeams[questions[1]] = [];
              }
              criticalTeams[questions[1]]['Company Alignment'] = 'Company Alignment';
            }
          } else if (questions[0] === '-L2ycGiBDo3rDGjLNKwW') {//Ambassadorship
            const thisweek = insightTeams[x][insightTeams[x].length - 1];
            if (color.includes(thisweek.color)) {
              if (criticalTeams[questions[1]] === undefined) {
                criticalTeams[questions[1]] = [];
              }
              criticalTeams[questions[1]]['Ambassadorship'] = 'Ambassadorship';
            }
          }
        }
      });
      firebase.firestore().collection('insight_manager_month').doc(`${selectTeam}`).collection('managers').where('updated', '>', format(addDays(companyNow, -30), 'YYYY-MM-DD')).get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            const data = doc.data()
            if (objData[data.email] === undefined) {
              objData[data.email] = new Array()
            }
            objData[data.email].team = doc.data().team;
            objData[data.email].daily = (data.report_daily_boss) ? Math.ceil(data.report_daily_boss) : 0
            if (objData[data.email].daily > 100) {
              objData[data.email].daily = 100
            }
            objData[data.email].weekly = (data.report_weekly_boss) ? Math.ceil(data.report_weekly_boss) : 0
            if (objData[data.email].weekly > 100) {
              objData[data.email].weekly = 100
            }
            objData[data.email].feedback = (data.feedback) ? Math.ceil(data.feedback) : 0
            if (objData[data.email].feedback > 100) {
              objData[data.email].feedback = 100
            }

            if (data.report_daily_boss >= 60 && data.report_weekly_boss >= 60 && data.feedback >= 25) {
              objData[data.email].active = 'Y'
              countAct += 1
            }
            if (data.report_daily_boss < 20 && data.report_weekly_boss < 20 && data.feedback < 10) {
              objData[data.email].passive = 'Y'
              countPas += 1
            }
          });

        });
      await firebase.firestore().collection('insight_manager_potential').where("company", "==", `${rootState.authen.user.company}`).where(`team.${selectTeam}`, "==", true).get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = doc.data()
            if (objData[data.email] === undefined) {
              objData[data.email] = new Array()
            }
            objData[data.email].potential = 'Y'
            countPot += 1
          });
          _.forEach(objData, async (value, index) => {
            let key = "";
            key = index.replace(/[+]/g, '\\$&')
            var re = new RegExp(key, 'gi')
            _.filter(state.membersall, (item): any => {
              if (item.email.match(re)) {
                if (item.profilepic_small) {
                  objData[index].profilepic = item.profilepic_small
                } else if (item.profilepic_crop) {
                  objData[index].profilepic = item.profilepic_crop
                } else {
                  objData[index].profilepic = item.profilepic
                }
                objData[index].shortname = item.firstname.charAt(0) + item.lastname.charAt(0)
                objData[index].fullname = item.firstname + " " + item.lastname
                objData[index].team_name = (state.teamkeys[item.team]) ? state.teamkeys[item.team].name : ''
                objData[index].talent = item.talent
                objData[index].network_type = item.network_type
                countAll++
              }
            });
            await firebase.firestore().collection('report_monthly_potential').where("email", "==", `${index}`).get()
              .then(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                  const data = doc.data()
                  if (objData[data.email] === undefined) {
                    objData[data.email] = new Array()
                  }
                  if (objData[data.email].super_feedback === undefined) {
                    objData[data.email].super_feedback = new Array()
                    objData[data.email].super_feedback.total = 0
                  }

                  if (data.supperfeedback) {
                    objData[data.email].super_feedback.total = Math.ceil((data.supperfeedback * 100) / data.answer)
                    if (objData[data.email].super_feedback.total > 100) {
                      objData[data.email].super_feedback.total = 100
                    }
                  }
                });
              });
            if (criticalTeams[index]) {
              objData[index].critical_area = Object.keys(criticalTeams[index]).toString();
            }
            listData.push({
              profilepic: objData[index].profilepic,
              shortname: objData[index].shortname,
              fullname: objData[index].fullname,
              team_name: objData[index].team_name,
              daily: (objData[index].daily) ? objData[index].daily : 0,
              weekly: (objData[index].weekly) ? objData[index].weekly : 0,
              feedback: (objData[index].feedback) ? objData[index].feedback : 0,
              super_feedback: (objData[index].super_feedback) ? objData[index].super_feedback.total : 0,
              talent: objData[index].talent,
              active: (objData[index].active && objData[index].active == 'Y') ? "Y" : "N",
              passive: (objData[index].passive && objData[index].passive == 'Y') ? "Y" : "N",
              potential: (objData[index].potential && objData[index].potential == 'Y') ? "Y" : "N",
              critical_area: (objData[index].critical_area) ? objData[index].critical_area : "",
              network_type: (objData[index].network_type) ? objData[index].network_type : "",
            });
          });
          commit('setCountAll', "(" + countAll + ")")
          commit('setCountAct', "(" + countAct + ")")
          commit('setCountPas', "(" + countPas + ")")
          commit('setCountPot', "(" + countPot + ")")
          commit('setDataList', listData)
          commit('setDataListAll', listData)
          commit('setLoadingTable', false)
        });
    },
    getDailyOpened({ commit, state }: any, selectTeam: any) {
      const activity: { [key: string]: firebase.firestore.DocumentData; } = {}
      firebase.firestore().collection('insight_manager').where("type", "==", 'report_daily_boss').where("team", "==", selectTeam).where("weekofyear", "==", state.weekofyear).get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            const data = doc.data()
            activity[state.weekofyear] = { total: Math.ceil((data.managers_opened * 100) / data.managers) }
          });
        });
      firebase.firestore().collection('insight_manager').where("type", "==", 'report_daily_boss').where("team", "==", selectTeam).where("weekofyear", "==", state.weekprevious).get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            const data = doc.data()
            activity[state.weekprevious] = { total: Math.ceil((data.managers_opened * 100) / data.managers) }
          });
          if (activity[state.weekprevious] && activity[state.weekofyear] && activity[state.weekprevious].total && activity[state.weekofyear].total) {
            if ((activity[state.weekprevious].total * 1) > (activity[state.weekofyear].total * 1)) {
              activity[state.weekofyear].calculate = -(activity[state.weekprevious].total - activity[state.weekofyear].total)
            } else if ((activity[state.weekofyear].total * 1) > (activity[state.weekprevious].total * 1)) {
              activity[state.weekofyear].calculate = activity[state.weekofyear].total - activity[state.weekprevious].total
            } else {
              activity[state.weekofyear].calculate = 0
            }
          } else {
            if (activity[state.weekofyear] === undefined) {
              activity[state.weekofyear] = new Array()
            }
            activity[state.weekofyear].calculate = 0
          }
          commit('setDailyOpened', activity[state.weekofyear])
        });
    },
    getWeeklyOpened({ commit, state }: any, selectTeam: any) {
      const activity: { [key: string]: firebase.firestore.DocumentData; } = {}
      firebase.firestore().collection('insight_manager').where("type", "==", 'report_weekly_boss').where("team", "==", selectTeam).where("weekofyear", "==", state.weekofyear).get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            const data = doc.data()
            activity[state.weekofyear] = { total: Math.ceil((data.managers_opened * 100) / data.managers) }
          });
        });
      firebase.firestore().collection('insight_manager').where("type", "==", 'report_weekly_boss').where("team", "==", selectTeam).where("weekofyear", "==", state.weekprevious).get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            const data = doc.data()
            activity[state.weekprevious] = { total: Math.ceil((data.managers_opened * 100) / data.managers) }
          });
          if (activity[state.weekprevious] && activity[state.weekofyear] && activity[state.weekprevious].total && activity[state.weekofyear].total) {
            if ((activity[state.weekprevious].total * 1) > (activity[state.weekofyear].total * 1)) {
              activity[state.weekofyear].calculate = -(activity[state.weekprevious].total - activity[state.weekofyear].total)
            } else if ((activity[state.weekofyear].total * 1) > (activity[state.weekprevious].total * 1)) {
              activity[state.weekofyear].calculate = activity[state.weekofyear].total - activity[state.weekprevious].total
            } else {
              activity[state.weekofyear].calculate = 0
            }
          } else {
            if (activity[state.weekofyear] === undefined) {
              activity[state.weekofyear] = new Array()
            }
            activity[state.weekofyear].calculate = 0
          }
          commit('setWeeklyOpened', activity[state.weekofyear])
        });
    },
    getFeedback({ commit, state }: any, selectTeam: any) {
      const activity: { [key: string]: firebase.firestore.DocumentData; } = {}
      firebase.firestore().collection('insight_manager').where("type", "==", 'feedback').where("team", "==", selectTeam).where("weekofyear", "==", state.weekofyear).get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            const data = doc.data()
            activity[state.weekofyear] = { total: Math.ceil((data.managers_opened * 100) / data.managers) }
          });
        });
      firebase.firestore().collection('insight_manager').where("type", "==", 'feedback').where("team", "==", selectTeam).where("weekofyear", "==", state.weekprevious).get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            const data = doc.data()
            activity[state.weekprevious] = { total: Math.ceil((data.managers_opened * 100) / data.managers) }
          });
          if (activity[state.weekprevious] && activity[state.weekofyear] && activity[state.weekprevious].total && activity[state.weekofyear].total) {
            if ((activity[state.weekprevious].total * 1) > (activity[state.weekofyear].total * 1)) {
              activity[state.weekofyear].calculate = -(activity[state.weekprevious].total - activity[state.weekofyear].total)
            } else if ((activity[state.weekofyear].total * 1) > (activity[state.weekprevious].total * 1)) {
              activity[state.weekofyear].calculate = activity[state.weekofyear].total - activity[state.weekprevious].total
            } else {
              activity[state.weekofyear].calculate = 0
            }
          } else {
            if (activity[state.weekofyear] === undefined) {
              activity[state.weekofyear] = new Array()
            }
            activity[state.weekofyear].calculate = 0
          }
          commit('setFeedback', activity[state.weekofyear])
        });
    },
    getInactive({ commit, state }: any, selectTeam: any) {
      const dailyOpened: any = [];
      const weeklyOpened: any = [];
      const feedbackOpened: any = [];
      let total_weekofyear = 0;
      const activity: { [key: string]: firebase.firestore.DocumentData; } = {}
      firebase.firestore().collection('insight_manager').doc(`${selectTeam}-${state.weekofyear}-report_daily_boss`).collection('managers').where('trackOpen', '==', false).get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = doc.data();
            dailyOpened.push(data)
          });
        });
      firebase.firestore().collection('insight_manager').doc(`${selectTeam}-${state.weekofyear}-report_weekly_boss`).collection('managers').where('trackOpen', '==', false).get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = doc.data();
            weeklyOpened.push(data)
          });
        });
      firebase.firestore().collection('insight_manager').doc(`${selectTeam}-${state.weekofyear}-feedback`).collection('managers').where('trackOpen', '==', false).get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = doc.data();
            feedbackOpened.push(data)
          });
          for (const i in dailyOpened) {
            for (const j in weeklyOpened) {
              if (dailyOpened[i].email == weeklyOpened[j].email) {
                for (const k in feedbackOpened) {
                  if (weeklyOpened[j].email == feedbackOpened[k].email) {
                    total_weekofyear++;
                  }
                }
              }
            }
          }
          activity[state.weekofyear] = { total: total_weekofyear }
        });

      const dailyOpened_previous: any = [];
      const weeklyOpened_previous: any = [];
      const feedbackOpened_previous: any = [];
      let total_weekprevious = 0;
      firebase.firestore().collection('insight_manager').doc(`${selectTeam}-${state.weekprevious}-report_daily_boss`).collection('managers').where('trackOpen', '==', false).get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = doc.data();
            dailyOpened_previous.push(data)
          });
        });
      firebase.firestore().collection('insight_manager').doc(`${selectTeam}-${state.weekofyear}-report_weekly_boss`).collection('managers').where('trackOpen', '==', false).get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = doc.data();
            weeklyOpened_previous.push(data)
          });
        });
      firebase.firestore().collection('insight_manager').doc(`${selectTeam}-${state.weekofyear}-feedback`).collection('managers').where('trackOpen', '==', false).get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = doc.data();
            feedbackOpened_previous.push(data)
          });
          for (const i in dailyOpened_previous) {
            for (const j in weeklyOpened_previous) {
              if (dailyOpened_previous[i].email == weeklyOpened_previous[j].email) {
                for (const k in feedbackOpened_previous) {
                  if (weeklyOpened_previous[j].email == feedbackOpened_previous[k].email) {
                    total_weekprevious++;
                  }
                }
              }
            }
          }
          activity[state.weekprevious] = { total: total_weekprevious }
          if (activity[state.weekprevious] && activity[state.weekofyear] && activity[state.weekprevious].total && activity[state.weekofyear].total) {
            if ((activity[state.weekprevious].total * 1) > (activity[state.weekofyear].total * 1)) {
              const value = Math.ceil((activity[state.weekofyear].total * 100) / activity[state.weekprevious].total);
              activity[state.weekofyear].calculate = -(100 - value)
            } else if ((activity[state.weekofyear].total * 1) > (activity[state.weekprevious].total * 1)) {
              const value = Math.ceil((activity[state.weekprevious].total * 100) / activity[state.weekofyear].total);
              activity[state.weekofyear].calculate = (100 - value)
            } else {
              activity[state.weekofyear].calculate = 0
            }
          } else {
            if (activity[state.weekofyear] === undefined) {
              activity[state.weekofyear] = new Array()
            }
            activity[state.weekofyear].calculate = 0
          }
          commit('setInactive', activity[state.weekofyear])
        });
    },
    async getActive({ commit, state, rootState }: any, selectTeam: any) {
      const timezone = await getCompanyTimezone(rootState.authen.user.company)
      const companyNow = toCompanyDate(new Date(), timezone)
      let startDate = format(addDays(companyNow, -30), 'YYYY-MM-DD')
      let listData: Array<any> = []
      var citiesRef = firebase.firestore().collection('insight_manager_month').doc(`${selectTeam}`).collection('managers');
      citiesRef.where("feedback", ">=", 25).get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (doc.data().report_daily_boss >= 60 && doc.data().report_weekly_boss >= 60 && doc.data().updated > startDate) {
              let temp = _.clone(doc.data())
              const item = _.filter(state.membersall, { 'email': doc.data().email })
              if (item[0]) {
                if (item[0]['profilepic_small']) {
                  temp.profilepic = item[0]['profilepic_small']
                } else if (item[0]['profilepic_crop']) {
                  temp.profilepic = item[0]['profilepic_crop']
                } else if (item[0]['profilepic']) {
                  temp.profilepic = item[0]['profilepic']
                } else {
                  temp.profilepic = ''
                }
                temp.shortname = item[0]['firstname'].charAt(0) + item[0]['lastname'].charAt(0)
                temp.fullname = item[0]['firstname'] + " " + item[0]['lastname']
                temp.team_name = (state.teamkeys[item[0]['team']])?state.teamkeys[item[0]['team']].name : ""

                listData.push({ profilepic: temp.profilepic, email: temp.email, shortname: temp.shortname, fullname: temp.fullname, team_name: temp.team_name });
              }
            }
          });
          commit('setActive', listData)
        });
    },
    async getPassive({ commit, state, rootState }: any, selectTeam: any) {
      const timezone = await getCompanyTimezone(rootState.authen.user.company)
      const companyNow = toCompanyDate(new Date(), timezone)
      let startDate = format(addDays(companyNow, -30), 'YYYY-MM-DD')
      let listData: Array<any> = []
      var citiesRef = firebase.firestore().collection('insight_manager_month').doc(`${selectTeam}`).collection('managers');
      citiesRef.where("report_daily_boss", "<", 20).get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (doc.data().feedback < 10 && doc.data().report_weekly_boss < 20 && doc.data().updated > startDate) {
              let temp = _.clone(doc.data())
              const item = _.filter(state.membersall, { 'email': doc.data().email })
              if (item[0]) {
                if (item[0]['profilepic_small']) {
                  temp.profilepic = item[0]['profilepic_small']
                } else if (item[0]['profilepic_crop']) {
                  temp.profilepic = item[0]['profilepic_crop']
                } else if (item[0]['profilepic']) {
                  temp.profilepic = item[0]['profilepic']
                } else {
                  temp.profilepic = ''
                }
                temp.shortname = item[0]['firstname'].charAt(0) + item[0]['lastname'].charAt(0)
                temp.fullname = item[0]['firstname'] + " " + item[0]['lastname']
                temp.team_name = (state.teamkeys[item[0]['team']])?state.teamkeys[item[0]['team']].name : ""

                listData.push({ profilepic: temp.profilepic, email: temp.email, shortname: temp.shortname, fullname: temp.fullname, team_name: temp.team_name });
              }
            }
          });
          commit('setPassive', listData)
        });
    },

    async getPotential({ commit, rootState, state }: any, selectTeam: any) {
      const timezone = await getCompanyTimezone(rootState.authen.user.company)
      const companyNow = toCompanyDate(new Date(), timezone)
      let startDate = format(addDays(companyNow, -30), 'YYYY-MM-DD')
      let listData: Array<any> = []
      var citiesRef = firebase.firestore().collection('insight_manager_potential').where("company", "==", `${rootState.authen.user.company}`).where(`team.${selectTeam}`, "==", true).get();
      citiesRef.then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          let temp = _.clone(doc.data())
          const item = _.filter(state.membersall, { 'email': doc.data().email })
          if (item[0]) {
            if (item[0]['profilepic_small']) {
              temp.profilepic = item[0]['profilepic_small']
            } else if (item[0]['profilepic_crop']) {
              temp.profilepic = item[0]['profilepic_crop']
            } else if (item[0]['profilepic']) {
              temp.profilepic = item[0]['profilepic']
            } else {
              temp.profilepic = ''
            }
            temp.shortname = item[0]['firstname'].charAt(0) + item[0]['lastname'].charAt(0)
            temp.fullname = item[0]['firstname'] + " " + item[0]['lastname']
            temp.team_name = (state.teamkeys[item[0]['team']])?state.teamkeys[item[0]['team']].name : ""

            listData.push({ profilepic: temp.profilepic, email: temp.email, shortname: temp.shortname, fullname: temp.fullname, team_name: temp.team_name });
          }
        });
        commit('setPotential', listData)
      });
    },

    getQuestionData({ rootState, state }: any, selectTeam: any) {
      const { questions } = state
      const activity: { [key: string]: firebase.firestore.DocumentData; } = {}
      firebase.firestore().collection('coaching_progress').where("company", "==", `${rootState.authen.user.company}`).where("team", "==", selectTeam).get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = doc.data();
            var re = new RegExp(data.quest_type, 'gi')
            _.filter(state.questions, (item): any => {
              if (item.name.match(re)) {
                if (activity[item.quest_id] === undefined) {
                  activity[item.quest_id] = new Array()
                }
                activity[item.quest_id].sent = (data.challenges_send) ? Math.ceil(data.challenges_send) : 0
                activity[item.quest_id].accept = (data.accept_rate) ? Math.ceil(data.accept_rate) : 0
                activity[item.quest_id].success = (data.success_rate) ? Math.ceil(data.success_rate) : 0
              }
            });
          });
          _.forEach(questions, (value, index) => {
            if (activity[questions[index].quest_id] !== undefined && activity[questions[index].quest_id].sent !== 0) {
              questions[index].sent = activity[questions[index].quest_id].sent
              questions[index].accept = activity[questions[index].quest_id].accept
              questions[index].success = activity[questions[index].quest_id].success
            } else {
              questions[index].sent = 0
              questions[index].accept = 0
              questions[index].success = 0
            }
          });
          ///SET DEFAULT SORT BY
          setTimeout(() => {
            state.questions = state.questions.sort((a, b) => { return (b.sent - a.sent) * -1; });
          }, 1000);
        });

    },

    async getQuestionsName({ state, commit }: any) {
      const { questions } = state
      const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
      
      // Use Promise.all to wait for all async operations to complete
      const promises = questions.map(async (value, index) => {
        const question = (await firebase.database().ref(`/questions/${questions[index].quest_id}`).once('value')).val();
        //questions[index].quest_name = (question_name[index]!=undefined)?question_name[index]:''
        
        // Choose the appropriate question text based on selected language
        let questionText = question.question_en; // Default to English
        
        if (selectedLanguage === 'th') {
          // Use the correct structure: questions.th
          if (question.questions && question.questions.th) {
            questionText = question.questions.th;
          }
          // If no Thai translation is available, keep English as fallback
        }
        
        commit('setQuestionsName', { id: questions[index].quest_id, value: questionText });
      });
      
      // Wait for all questions to be processed
      await Promise.all(promises);
    },
    searchByStatus({ commit, dispatch }: any, status: any) {
      dispatch('reponseSearchAll', status).then((result) => {
        commit('setDataList', result[0])
      });
    },
    async reponseSearchAll({ state }: any, status: any) {
      const data: Array<any> = []
      let listData: Array<any> = []
      if (status) {
        if (status == 'active') {
          listData = _.filter(state.datalistAll, (item): any => {
            if (item.active && item.active.match("Y")) {
              return true
            }
          });
        } else if (status == 'passive') {
          listData = _.filter(state.datalistAll, (item): any => {
            if (item.passive && item.passive.match("Y")) {
              return true
            }
          });
        } else if (status == 'potential') {
          listData = _.filter(state.datalistAll, (item): any => {
            if (item.potential && item.potential.match("Y")) {
              return true
            }
          });
        }
      } else {
        listData = state.datalistAll
      }
      data.push(listData)
      return data
    },
  },
  getters: {
    dailyopened: (state: any) => {
      return state.dailyopened
    },
    weeklyopened: (state: any) => {
      return state.weeklyopened
    },
    feedback: (state: any) => {
      return state.feedback
    },
    inactive: (state: any) => {
      return state.inactive
    },
    active: (state: any) => {
      return state.active
    },
    passive: (state: any) => {
      return state.passive
    },
    potential: (state: any) => {
      return state.potential
    },
    dateshow: (state: any) => {
      return state.dateshow
    },
    questions: (state: any) => {
      return state.questions
    },
    questions_name: (state: any) => {
      return state.questions_name
    },
    teamselected: (state: any) => {
      return state.teamselected
    },
    datalist: (state: any) => {
      return state.datalist
    },
    countAll: (state: any) => {
      return state.countAll
    },
    countAct: (state: any) => {
      return state.countAct
    },
    countPas: (state: any) => {
      return state.countPas
    },
    countPot: (state: any) => {
      return state.countPot
    },
    loadingTable: (state: any) => {
      return state.loadingTable;
    }
  }
}
